module.exports = __webpack_public_path__ + "static/img/pk.c2e1a159.svg";